import axios from 'axios';
import config from '../config';
import { SystemConfiguration } from '../interfaces';

export const getSystemConfigurations = (): Promise<SystemConfiguration[]> => {
    return axios.get(`${config.API_URL}/system/configurations`).then((response: any) => {
        return response.data.data.configurations;
    });
};
